<template>
  <div class="simulation-container">
    <div class="l-main">
      <section class="ttl-com is-simulation">
        <div class="ttl-com__wrap01">
          <p class="ttl-com__cate is-blue">{{ company.industry_name }}</p>
          <p class="ttl-com__cate is-green">{{ company.prefecture_name }}</p>
          <p v-if="company.employee_category" class="ttl-com__cate">{{ company.employee_category }}</p>
        </div>
        <h1 class="ttl-com__ttl">{{ company.company_name }}</h1>
        <div class="ttl-com__wrap02">
          <div class="sns">
            <a
                v-if="company.company_video_status"
                :href="`/companies/${company.company_id}#video`"
                class="btn-short"
            >ショート動画</a>
            <Like :company="company"></Like>
            <Share :company="company"></Share>
          </div>
        </div>
      </section>
      <section class="simulation">
        <div class="simulation__wrap">
          <div class="simulation__wrap-m">
            <p class="simulation__ttl is-ttl01">初任給総支給額<small class="simulation__txt-s">（月額）</small></p>
            <p class="simulation__income">
              {{ company.job_type }}：{{ company.education_level_name }}
              <span>
                  <strong class="">{{ company.salary.toLocaleString() }}</strong>
                  <small class="simulation__income-s">円</small>
                </span>
            </p>
          </div>
          <div class="simulation__wrap-m">
            <p class="simulation__ttl is-ttl02">控除額</p>
            <table>
              <tbody>
              <tr>
                <th>
                  <p class="simulation__txt">
                    社会保険料
                    <small class="simulation__txt-s">（月額）</small>
                  </p>
                </th>
                <td>
                  <p class="simulation__amount">
                    {{ company.social_insurance.toLocaleString() }}
                    <small class="simulation__txt-l">円</small>
                  </p>
                </td>
              </tr>
              <tr>
                <th>
                  <p class="simulation__txt">
                    所得税
                    <small class="simulation__txt-s">（月額）</small>
                  </p>
                </th>
                <td>
                  <p class="simulation__amount">
                    {{ company.income_tax.toLocaleString() }}
                    <small class="simulation__txt-l">円</small>
                  </p>
                </td>
              </tr>
              <tr>
                <th>
                  <p class="simulation__txt">
                    住民税
                    <small class="simulation__txt-s">（月額）</small>
                  </p>
                </th>
                <td>
                  <span class="simulation__txt is-height">（一年目はなし）</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="simulation__wrap-m">
            <p class="simulation__ttl is-ttl03">手取り額
              <small class="simulation__txt-s">（月額）</small>
            </p>
            <p class="simulation__body">注）推計の社会保険料や所得税額を基にした概算値</p>
            <p class="simulation__income">
                  <span>
                      <strong class="">{{ company.take_home_pay.toLocaleString() }}</strong>
                      <small class="simulation__income-s">円</small>
                  </span>
            </p>
          </div>
        </div>
      </section>
      <section class="real">
        <div class="real-wrap">
          <div class="real__wrap-ttl-bubble">
            <h3 class="ttl-bubble is-simulation">社会人1年目のお金のリアル</h3>
          </div>
          <div class="result">
            <div class="result__bg"></div>
            <div class="result__frame"></div>
            <div class="result__wrap">
              <div class="result__ajuster">
                <div class="result__val" :style="resultParStyle"></div>
              </div>
            </div>
            <div class="result__wrap is-visible">
              <div class="result__arr" :style="resultParStyleArr"></div>
            </div>
          </div>
          <p class="real__txt-l">ひと月の自由に使えるお金</p>
          <p class="real__txt-s">（手取り額 − 月々の支出）</p>
          <p class="real__amount"><strong>{{ simulationStore.free_money.toLocaleString() }}</strong>円</p>
        </div>

      </section>

      <div class="graph">
        <h2 class="graph-ttl"><span></span>支出を入力</h2>
        <div class="graph__wrap">
          <Range :type="simulationStore.TYPE_RENT"></Range>
          <RangeLiving></RangeLiving>
          <Range :type="simulationStore.TYPE_OTHER"></Range>
        </div>
        <a :href="companyLink" class="simu-link">企業TOPへ戻る</a>
      </div>

    </div>

    <button v-if="isLogin" @click="save" type="button" class="btn-sim">結果を保存</button>
    <button v-if="!isLogin" type="button" class="btn-sim" disabled>結果を保存</button>


  </div>
</template>

<script setup lang="ts">
import Like from "../parts/Like.vue";
import Share from "../parts/Share.vue";
import Range from "../parts/Range.vue";
import {NaviClient} from "../../api/NaviClient";
import RangeLiving from "../parts/RangeLiving.vue";
import {usePageStore} from "../../stores/page";
import {useSimulationStore} from "../../stores/simulation";
import {Bootstrap} from "../../Bootstrap";
import {computed} from "vue";

const pageDataStore = usePageStore();
const company = pageDataStore.pageData;
const simulationStore = useSimulationStore();
simulationStore.init(company);

const isLogin = globalThis.IS_USER_LOGIN;

const companyLink = computed(() => {
  return `/companies/${company.company_id}`;
})

const resultParStyle = computed(() => {
  let stylePar: any = simulationStore.total / company.take_home_pay; // 支出 / 手取 = 出費の割合
  if (stylePar > 1) { //最大1に均す
    stylePar = 1;
  }
  stylePar *= 100; //比率 > %パーセントへ
  return `top: ${stylePar}%`;
});
const resultParStyleArr = computed(() => {
  let stylePar: any = simulationStore.total / company.take_home_pay; // 支出 / 手取 = 出費の割合
  if (stylePar > 1) { //最大1に均す
    stylePar = 1;
  }
  stylePar = stylePar * 100 * 0.5; //比率 > %パーセントへ 0.5を掛けて位置を調整
  return `top: ${stylePar}%`;
});

// save
const save = () => {
  if (!globalThis.IS_USER_LOGIN) {
    Bootstrap.login();
    return;
  }

  NaviClient.simulation(company.company_id, {
    job_type: company.job_type,
    education_level_id: company.education_level_id,
    rent: simulationStore.rent,
    other: simulationStore.other,
    living: simulationStore.living,
    living_utility: simulationStore.living_utility,
    living_tel: simulationStore.living_tel,
    living_food: simulationStore.living_food,
    living_daily: simulationStore.living_daily,
    living_trans: simulationStore.living_trans,
    living_entertainment: simulationStore.living_entertainment,
    living_other: simulationStore.living_other
  }).then((json) => {
    Bootstrap.save();
    console.log(json);
  }).catch((error) => {
    console.log(error);
  })
  console.log('>>>>save');
};
</script>